import { render, staticRenderFns } from "./DepositedEntryDetails.vue?vue&type=template&id=a571eb30&scoped=true&"
import script from "./DepositedEntryDetails.vue?vue&type=script&lang=js&"
export * from "./DepositedEntryDetails.vue?vue&type=script&lang=js&"
import style0 from "./DepositedEntryDetails.vue?vue&type=style&index=0&id=a571eb30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a571eb30",
  null
  
)

export default component.exports